<script>
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwNotification from '@/components/generic/notification/tw-notification.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import modalCascadeMixin from '@/mixins/modalCascadeMixin.js'
import TwButton from '@/components/generic/tw-button.vue'
import TwNumber from '@/components/generic/forms/tw-number.vue'

export default {
  name: 'DonationAppFeeChangeModal' ,
  components: { TwNumber, TwButton, TwModal, TwNotification, TwTransitionContainer },
  mixins: [modalCascadeMixin],
  props:{
    modelValue: {
      type: [Number],
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      ShowAppFeeEditor: false,
    }
  },
  methods: {
    saveAndClose() {
      this.close()
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" no-footer title="We’re passionate about helping nonprofits raise more money for less. That’s why GroupRev is 100% free for them to use—no platform fees, ever." size="sm" ok-text="Sounds Good">
    <div class="text-sm grid gap-4 text-gray-900">
      <div class="flex flex-col gap-4">
        <p> This is only possible because generous donors like you choose to add a small contribution to help cover the real costs (servers, security, and software improvements). Our suggested contribution is about half of what other platforms charge, and every dollar keeps fundraising accessible to all.</p>
        <p> If you’d prefer not to contribute, you can remove it and still support this fundraiser. </p>
      </div>
       <tw-transition-container>
        <div v-if="ShowAppFeeEditor" class="mt-4">
          <div> <tw-number :model-value="modelValue" label="Optional Contribution Amount"  prepend="$" @keyup.enter="saveAndClose" @update:model-value="$emit('update:modelValue', $event)" /> </div>
          <div class="pt-8 flex flex-row justify-end gap-3">
            <div>
              <tw-button variant="secondary" @click="close()" class="grow">
                Cancel
              </tw-button>
            </div>
            <div>
              <tw-button variant="amber" @click="saveAndClose" class="w-full sm:w-auto">
                Save
              </tw-button>
            </div>
          </div>
        </div>
        <div v-else class="flex flex-row flex-wrap justify-end gap-3 mt-4">
          <tw-button variant="amber" @click="close()" block class="w-full sm:w-auto">
            Sounds Good
          </tw-button>
          <tw-button variant="secondary" @click="ShowAppFeeEditor = true" class="w-full sm:w-auto" block>
            Change Optional Amount
          </tw-button>
        </div>
      </tw-transition-container>
    </div>
    <tw-notification>
      <div class="text-center">
        <p> Optional contribution saved! </p>
      </div>
    </tw-notification>
  </tw-modal>
</template>

<style scoped>

</style>
